import { render } from "./ListeProduitIventaire.vue?vue&type=template&id=5787ab0c&ts=true"
import script from "./ListeProduitIventaire.vue?vue&type=script&lang=ts"
export * from "./ListeProduitIventaire.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__